// component
import {
  Dashboard as DashboardIcon,
  Search as SearchIcon,
  People as PeopleIcon,
  Event as EventIcon,
  Schedule as ScheduleIcon,
  AccountCircle as AccountCircleIcon,
  School as SchoolIcon,
  Notifications as NotificationsIcon,
  ManageAccounts as ManageAccountsIcon,
  Settings as SettingsIcon,
  Group as GroupIcon,
  Send as SendIcon,
  Security as SecurityIcon,
  Handshake as HandshakeIcon,
  FormatQuote as FormatQuoteIcon,
  History as HistoryIcon,
  Message as MessageIcon,
} from '@mui/icons-material';

// ----------------------------------------------------------------------

export const navConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: DashboardIcon,
    tourId: 'sidebar-dashboard',
  },
  {
    title: 'Find An Edifier',
    path: '/dashboard/find-edifiers',
    icon: SearchIcon,
    breadCrumbs: ['/dashboard/find-edifiers', '/dashboard/user-profile', '/dashboard/user-timeslots'],
    tourId: 'sidebar-edifiers',
  },
  {
    title: 'Your Edifiers',
    path: '/dashboard/paired',
    icon: PeopleIcon,
    tourId: 'sidebar-pairing',
  },
  {
    title: 'Mentoring Session Invites',
    path: '/dashboard/meeting-invites',
    icon: NotificationsIcon,
    tourId: 'sidebar-invites',
  },
  {
    title: 'Upcoming Mentoring Sessions',
    path: '/dashboard/upcoming-events',
    icon: EventIcon,
    tourId: 'sidebar-sessions',
  },
  {
    title: 'My Availability',
    path: '/dashboard/timeslots',
    icon: ScheduleIcon,
    tourId: 'sidebar-availability',
  },
  {
    title: 'Profile',
    path: '/dashboard/my-profile',
    icon: AccountCircleIcon,
    tourId: 'header-profile',
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: SettingsIcon,
  },
];

export const navConfigEdifier = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: DashboardIcon,
    tourId: 'sidebar-dashboard',
  },
  {
    title: 'Your Mentees',
    path: '/dashboard/teachers',
    icon: GroupIcon,
    breadCrumbs: ['/dashboard/teachers', '/dashboard/user-profile', '/dashboard/user-timeslots'],
    tourId: 'sidebar-teachers',
  },
  {
    title: 'Mentoring Session Invites',
    path: '/dashboard/meeting-invites',
    icon: NotificationsIcon,
    tourId: 'sidebar-invites',
  },
  {
    title: 'Upcoming Mentoring Sessions',
    path: '/dashboard/upcoming-events',
    icon: EventIcon,
    tourId: 'sidebar-sessions',
  },
  {
    title: 'My Availability',
    path: '/dashboard/timeslots',
    icon: ScheduleIcon,
    tourId: 'sidebar-availability',
  },
  {
    title: 'Profile',
    path: '/dashboard/my-profile',
    icon: AccountCircleIcon,
    tourId: 'header-profile',
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: SettingsIcon,
  },
];

export const navConfigSudo = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: DashboardIcon,
    tourId: 'sidebar-dashboard',
  },
  {
    title: 'Add / Change Partnership Site',
    path: '/dashboard/find-schools',
    icon: SchoolIcon,
    tourId: 'sidebar-schools',
  },
  {
    title: 'Add / Change User Profiles',
    path: '/dashboard/find-edifiers',
    icon: ManageAccountsIcon,
    tourId: 'sidebar-users',
  },
  {
    title: 'Manage Principals',
    path: '/dashboard/manage-principals',
    icon: ManageAccountsIcon,
    tourId: 'sidebar-principals',
  },
  {
    title: 'Manage Credentials',
    path: '/dashboard/manage-credentials',
    icon: SecurityIcon,
    tourId: 'sidebar-credentials',
  },
  {
    title: 'Pairing Management',
    path: '/dashboard/manage-pairings',
    icon: HandshakeIcon,
    tourId: 'sidebar-pairing',
  },
  {
    title: 'Pairing/Update Requests',
    path: '/dashboard/requests',
    icon: HandshakeIcon,
    tourId: 'sidebar-requests',
  },
  {
    title: 'Send Notifications',
    path: '/dashboard/send-notifications',
    icon: SendIcon,
    tourId: 'sidebar-notifications',
  },
  {
    title: 'Quote Management',
    path: '/dashboard/quote-management',
    icon: FormatQuoteIcon,
    tourId: 'sidebar-quotes',
  },
  {
    title: 'Audit Logs',
    path: '/dashboard/audit-logs',
    icon: HistoryIcon,
    tourId: 'sidebar-audit-logs',
  },
  {
    title: 'Chat with Users',
    path: '/dashboard/admin-chat',
    icon: MessageIcon,
    tourId: 'sidebar-admin-chat',
  },
  {
    title: 'Profile',
    path: '/dashboard/my-profile',
    icon: AccountCircleIcon,
    tourId: 'header-profile',
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: SettingsIcon,
  },
];

export const siteLeaderNav = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: DashboardIcon,
    tourId: 'sidebar-dashboard',
  },
  {
    title: 'Manage Users',
    path: '/dashboard/district-users',
    icon: ManageAccountsIcon,
    tourId: 'sidebar-users',
  },
  {
    title: 'Pairing Management',
    path: '/dashboard/manage-pairings',
    icon: HandshakeIcon,
    tourId: 'sidebar-pairing',
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: SettingsIcon,
  },
];

export const principalNavConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/principal/dashboard',
    icon: DashboardIcon,
    tourId: 'sidebar-dashboard',
  },
  {
    title: 'Users',
    path: '/dashboard/principal/users',
    icon: ManageAccountsIcon,
    tourId: 'sidebar-teachers',
  },
  {
    title: 'Pairing Management',
    path: '/dashboard/principal/pairings',
    icon: HandshakeIcon,
    tourId: 'sidebar-pairing',
  },
  // {
  //   title: 'Profile',
  //   path: '/dashboard/my-profile',
  //   icon: AccountCircleIcon,
  // },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: SettingsIcon,
  },
];
